<template>
  <transition name="modal-fade">
    <div class="modal-backdrop">
      <card>
        <div
          class="col-md-12 col-lg-12 col-sm-12"
          role="dialog"
          aria-labelledby="modalTitle"
          aria-describedby="modalDescription"
        >
          <div class="modal-body">
            <div>
              <h4
                slot="header"
                id="modalTitle"
                class="card-title mb-3 text-align-center"
              >
                {{ `${titulo} Anuncio` }}
              </h4>

              <form id="modalDescription">
                <div class="row pl-3">
                  <base-input
                    type="text"
                    label="Nome"
                    v-model="anuncio.nome"
                    @input="validaCampos()"
                    @change="validaCampos()"
                  ></base-input>
                </div>

                <hr />
                <label for="anuncioImagem">imagem</label>
                <div class="row pl-3 align-items-center">
                  <button
                    id="upload_widget"
                    class="d-inline"
                    @click.prevent="uploadImage"
                    v-if="!anuncio.imagem"
                  >
                    Selecionar imagem
                  </button>
                  <div class="d-inline align-self-center" v-if="anuncio.imagem">
                    <img
                      :src="anuncio.imagem"
                      alt="Foto do perfil"
                      id="profile-photo"
                    />
                    <button
                      class="btn btn-icon btn-danger ml-2"
                      @click.prevent="deleteImage()"
                    >
                      <i class="fa fa-trash-o"></i>
                    </button>
                  </div>
                </div>
                <div class="text-center mt-4">
                  <button
                    type="submit"
                    class="btn btn-success btn-fill float-right"
                    @click.prevent="salvarAnuncios"
                    :disabled="erroValidacao"
                  >
                    <i class="fa fa-floppy-o" aria-hidden="true"></i> Salvar
                  </button>
                  <button
                    @click.prevent
                    class="btn btn-danger btn-fill float-left"
                    @click="close"
                  >
                    <i class="fa fa-times" aria-hidden="true"></i> Fechar
                  </button>
                </div>
                <div class="clearfix"></div>
              </form>
            </div>
          </div>
        </div>
      </card>
    </div>
  </transition>
</template>

<script>
import Card from 'src/components/Cards/Card.vue';
import AnunciosServices from 'src/services/anuncios';
import _ from 'lodash';

const VUE_APP_SPINNER_COLOR = process.env.VUE_APP_SPINNER_COLOR;

export default {
  components: {
    Card
  },
  props: {
    afterCreateAction: Function,
    action: String,
    anuncio: {
      imagem: '',
      nome: ''
    }
  },
  data() {
    return {
      notifications: {
        topCenter: false
      },
      simple: '',
      name: 'modal',
      erroValidacao: true
    };
  },
  computed: {
    titulo() {
      if (this.action === 'EDIT') {
        return 'Editar';
      } else if (this.action === 'NEW') {
        return 'Cadastrar';
      }
    },
    hasUrlFoto() {
      return this.anuncio && this.anuncio.imagem;
    }
  },
  methods: {
    salvarAnuncios() {
      const loader = this.$loading.show({
        color: VUE_APP_SPINNER_COLOR
      });

      const sucessCallback = () => {
        this.notifyVue(
          'top',
          'center',
          'success',
          'Salvo com Sucesso.',
          'fa fa-check'
        );
        this.afterCreateAction();
        this.close();
        loader.hide();
      };

      const errorCallback = err => {
        const message =
          _.get(err, 'response.status') === 400 &&
          _.has(err, 'response.data.message')
            ? _.get(err, 'response.data.message')
            : 'Ocorreu algum erro interno. Tente novamente mais tarde.';

        this.notifyVue(
          'top',
          'center',
          'danger',
          message,
          'fa fa-exclamation-triangle'
        );
        loader.hide();
      };

      const { anuncio } = this;

      if (anuncio._id) {
        AnunciosServices.atualizar(anuncio)
          .then(sucessCallback)
          .catch(errorCallback);
      } else {
        AnunciosServices.salvar(anuncio)
          .then(sucessCallback)
          .catch(errorCallback);
      }
    },
    close() {
      this.$emit('close');
    },
    notifyVue(verticalAlign, horizontalAlign, type, message, icon) {
      this.$notifications.notify({
        message: `<span>${message}.</span>`,
        icon: icon,
        horizontalAlign: horizontalAlign,
        verticalAlign: verticalAlign,
        type: type
      });
    },
    uploadImage() {
      // eslint-disable-next-line no-undef
      const myWidget = cloudinary.createUploadWidget(
        {
          cloudName: 'dy8mstmqs',
          uploadPreset: 'afqwmioy',
          sources: ['local'],
          maxFiles: 1,
          apiKey: '456183971343259'
        },
        (error, result) => {
          if (!error && result && result.event === 'success') {
            this.anuncio.imagem = result.info.url;
            const nome = this.anuncio.nome;
            this.anuncio.nome = nome + ' ';
            this.anuncio.nome = nome;
            this.validaCampos();
          }
        }
      );
      myWidget.open();
    },
    deleteImage() {
      this.anuncio.imagem = '';
      const nome = this.anuncio.nome;
      this.anuncio.nome = nome + ' ';
      this.anuncio.nome = nome;
    },
    validaCampos() {
      if (
        this.anuncio.nome == '' ||
        !this.anuncio.nome ||
        this.anuncio.imagem == '' ||
        !this.anuncio.imagem
      ) {
        this.erroValidacao = true;
      } else this.erroValidacao = false;
    }
  }
};
</script>
<style scoped>
.modal-fade-enter,
.modal-fade-leave-active {
  opacity: 0;
}

.modal-fade-enter-active,
.modal-fade-leave-active {
  transition: opacity 0.5s ease;
}
.modal-backdrop {
  position: fixed;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  background-color: rgba(0, 0, 0, 0.3);
  display: flex;
  justify-content: center;
  align-items: center;
}

#modalDescription {
  width: 350px;
}

.modal-body {
  position: relative;
}

#profile-photo {
  width: 7em;
  height: 7em;
}

#upload_widget {
  max-height: 30px;
}

.form-group {
  width: 100%;
}
</style>
